<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';

import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
import ButtonAnySearch from '@/components/left-panel/any-button/ButtonAnySearch.vue';
import ToggleButton from '@/components/left-panel/any-button/ToggleButton.vue';
import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

import UserSearchPanel from '@/components/page-user-edit/user-search/UserSearch.vue';

import UserAdd from '@/components/page-user-edit/user-add/UserAdd.vue';
import UserEdit from '@/components/page-user-edit/user-edit/UserEdit.vue';
import RoleAdd from '@/components/page-user-edit/role-add/RoleAdd.vue';
import RoleEdit from '@/components/page-user-edit/role-edit/RoleEdit.vue';

import UserList from '@/components/page-user-edit/UserList.vue';
import RoleList from '@/components/page-user-edit/RoleList.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';
import constants from '@/constants';

export default {
    data() {
        return {
            isShowUser: true,
            constants: constants,
        };
    },
    components: {
        MainContainer: MainContainer,
        LeftPanel: LeftPanel,
        RightContainer: RightContainer,

        ButtonAnyNew: ButtonAnyNew,
        ButtonAnySearch: ButtonAnySearch,
        ToggleButton: ToggleButton,
        ButtonReturn: ButtonReturn,

        UserSearchPanel: UserSearchPanel,

        UserAdd: UserAdd,
        UserEdit: UserEdit,
        RoleAdd: RoleAdd,
        RoleEdit: RoleEdit,

        UserList: UserList,
        RoleList: RoleList,
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        // Load users with pagination
        await this.$store.dispatch('loadUsers');

        // Load roles for filter dropdown
        const promiseList = await calculatePromise([
            { dispatch: 'CHECK_ROLES_AXIOS', commit: 'ROLES', isArray: false },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);

        // Check if userId is in URL and open user edit
        const userId = this.$route.params.userId;
        if (userId) {
            const user = this.$store.getters.USERS.find(
                (u) => u.id === parseInt(userId)
            );
            if (user) {
                this.$store.commit('IS_SHOW_USER_EDIT', true);
                this.$store.commit('USER_EDIT_SET', user);
                await this.$store.dispatch('CHECK_USER_EDIT');
            } else {
                // User not found, redirect to user-edit without ID
                this.$router.push({
                    name: this.$constants.ROUTER_NAME.USEREDIT,
                });
            }
        }
    },
    watch: {
        '$route.params.userId': {
            async handler(newUserId) {
                if (newUserId) {
                    const user = this.$store.getters.USERS.find(
                        (u) => u.id === parseInt(newUserId)
                    );
                    if (user) {
                        this.$store.commit('IS_SHOW_USER_EDIT', true);
                        this.$store.commit('USER_EDIT_SET', user);
                        await this.$store.dispatch('CHECK_USER_EDIT');
                    }
                } else {
                    // No userId in URL, close edit panel
                    this.$store.commit('IS_SHOW_USER_EDIT', false);
                }
            },
        },
    },
    methods: {
        async togglePage() {
            this.isShowUser = !this.isShowUser;
        },
        async toggleUserAdd() {
            this.$store.commit(
                'IS_SHOW_UDER_ADD',
                this.$store.getters.IS_SHOW_UDER_ADD === false
            );
        },
        async toggleRoleAdd() {
            this.$store.commit(
                'IS_SHOW_ROLE_ADD',
                this.$store.getters.IS_SHOW_ROLE_ADD === false
            );
        },
        async toggleUserSearch() {
            this.$store.commit(
                'IS_SHOW_USER_SEARCH',
                this.$store.getters.IS_SHOW_USER_SEARCH === false
            );
        },
    },
};
</script>

<template>
    <UserSearchPanel />

    <UserAdd />
    <RoleAdd />
    <UserEdit />
    <RoleEdit />

    <MainContainer>
        <LeftPanel>
            <ButtonAnyNew title="New User" :method="toggleUserAdd" />
            <ButtonAnyNew title="New Role" :method="toggleRoleAdd" />
            <hr class="left-separator" />
            <ButtonAnySearch title="Search User" :method="toggleUserSearch" />
            <hr class="left-separator" />
            <ToggleButton
                :toggle="isShowUser"
                :method="togglePage"
                title="User"
            />
            <ToggleButton
                :toggle="!isShowUser"
                :method="togglePage"
                title="Role"
            />
            <hr class="left-separator" />
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <UserList v-if="isShowUser" />
            <RoleList v-else />
        </RightContainer>
    </MainContainer>
</template>
